import {
    createIconTextComponent,
    IIconTextProperties,
} from '@vfde-brix-ws10/icon-text';
import {NO_PATTERN_BUSINESS_LOGIC} from '@vfde-brix-ws10/core';
import { ID_WEBCHAT_HEADER, WRAPPER_ICON_TEXT_NAME } from 'Container/Ui/constants';
import { renderContainerForWebchatContent } from 'Container/Ui/helpers/renderContainerForWebchatContent';

/**
 * IconText Component has two shapes.
 */
export type IconTextVariant = 'img-headline-subline' | 'icon-text';
/**
 * mount new Icon Text Component
 * @param containerElement
 */
export const mountIconTextComponent = (containerElement: HTMLElement, content: string, imgIconSrc: string, headline?: string) => {

    const iconTextProperties: IIconTextProperties = {
        optIconSize: 'meduim',
        txtContent: content,
        business: NO_PATTERN_BUSINESS_LOGIC,
        imgMidRenderIconPath: imgIconSrc,
        optAlignment: 'left',
    };

    createIconTextComponent(containerElement, iconTextProperties);
};

/**
 * renderAgentTakeover
 */
export const renderAgentTakeover = () => {
    // create unique container for webchat icon-text
    const containerForIconText = renderContainerForWebchatContent(WRAPPER_ICON_TEXT_NAME);
    mountIconTextComponent(
        document.getElementById(containerForIconText),
        'Du bist jetzt mit der Vodafone Kundenbetreuung verbunden',
        '/media/img/icons/contact-us-webchat.svg',
    );

    /**
     * Basically, a pointer to the brix component plus calling the
     * update method would be the prefered way. But as agent takeover
     * is not more than a step child right now, i'm going the MVP way
     * and mount a new component with the new texts (hbo)
     */
    mountIconTextComponent (
        document.getElementById(ID_WEBCHAT_HEADER) as HTMLElement,
        '<h3>Kundenberatung</h3>',
        '/media/img/icons/mid-render/tobi-chat-header-agent.svg',
        'Vodafone',
    );

};
